import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'
import { getGenerationDashboard } from '@ebalance/proto/bffuser/v1/balance_service-BalanceGenerationService_connectquery'
import {
  GetGenerationDashboardRequestSchema,
  type GetGenerationDashboardResponse,
} from '@ebalance/proto/bffuser/v1/balance_service_pb'
import { keepPreviousData } from '@tanstack/react-query'

import { isRegionLoading } from '~/hooks/isRegionLoading'
import { toProtoDate } from '~/models/dateTime'

// Re-export types so existing consumers (BgGrid etc.) can keep their import path
export type {
  BgApiData,
  GenerationDashboardData,
} from '~/pages/BalanceGeneration/models/convertGenerationResponse'

export function useGenerationDashboard(displayDate: Date): {
  data: GetGenerationDashboardResponse | undefined
  isError: boolean
  /** 領域を影 + スピナーで覆うか。 判断は `~/hooks/isRegionLoading`。 */
  isRegionLoading: boolean
} {
  const query = useQuery(
    getGenerationDashboard,
    create(GetGenerationDashboardRequestSchema, {
      displayDate: toProtoDate(displayDate),
    }),
    {
      refetchInterval: 5_000,
      // 表示日を変えた直後も前の日のカードを残す (需要側 `useDemandDashboard` と同じ。
      // UI 辞書 components/region-loading.md)。
      placeholderData: keepPreviousData,
      // `ApiClientProvider` の既定は `throwOnError: true` (= 取得失敗を render 中に
      // throw して router の errorElement = 全画面エラーへ飛ばす)。 この画面は
      // spec (AC-BDB-013 / AC-BDH-013) が**画面内のエラーバナー**を要求するので、
      // この query だけ false に上書きして `isError` を購読側で扱う
      // (`WorkflowBackBar` と同じ形。 throwOnError は observer ごとに評価される)。
      throwOnError: false,
    },
  )
  return {
    data: query.data,
    isError: query.isError,
    isRegionLoading: isRegionLoading(query),
  }
}
